import API from "./../../api";

export default () => {
    let filterAplied =  JSON.parse(localStorage.getItem('filterCohortBuilder'));
    return API.get(`api/cohort-builder/cohorts?per_page=50&filter=${JSON.stringify(filterAplied)}`)
}
